












import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import slugify from 'slugify';
import { FETCH_PDF } from '../store';
import { ApiResponse } from '@/components/types';
import { Compensation } from '@/modules/compensation/types';

const Compensation = namespace('compensation');

@Component({})
export default class DownloadAction extends Vue {
  @Prop({ type: Object, required: true }) compensation!: Compensation;
  @Prop({ type: String, default: 'btn-info' }) color!: string;
  @Prop({ type: Boolean, default: false }) large!: boolean;
  @Prop({ type: Boolean, default: true }) icon!: boolean;
  @Prop({ type: String }) label?: string;

  @Compensation.Action(FETCH_PDF) fetchPDF!: (id: string) => Promise<ApiResponse>;

  loading: boolean = false;
  error: any = null;

  get filename(): string {
    return `Verguetungsantrag-${slugify(this.compensation.conservatee.surname)}-${this.compensation.invoiceNumber}.pdf`;
  }

  async download() {
    this.error = null;
    this.loading = true;

    const { error, content } = await this.fetchPDF(this.compensation.id);

    if (error) {
      this.error = error;
      this.loading = false;
      return;
    }

    this.loading = false;

    const link = document.createElement('a');
    link.href = URL.createObjectURL(content);
    link.setAttribute('download', this.filename);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
